import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onBeforeMount } from "vue";
import { useRouter, useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'vendorRequestedCallback',
  setup(__props) {

const route = useRoute();
const router = useRouter();

onBeforeMount(() => {
  const token = route.query.token;
  router.push({ name: "AssessmentVendorExternalCallback", query: { token } });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})